import { default as dayjs } from 'dayjs';

export const formatDate = (date: string, dateFormat = 'MMMM D, YYYY h:mm A') => dayjs(date).format(dateFormat);


